import {CaptchaClient, ICaptchaClient} from "../api/WickedApiClient";
import {Injectable} from "@angular/core";
import { environment } from "../../environments/environment";


@Injectable({
  providedIn: "root"
})
export class CaptchaService {

  private captchaClient: ICaptchaClient;

  private captchaKey: string = "";

  constructor(captchaClient: CaptchaClient) {
    this.captchaClient = captchaClient;
    this.obtainCaptchaSiteKeyFromServer()
  }

  public getCurrentCaptchaKey() {
    return this.captchaKey
  }

  public obtainCaptchaSiteKeyFromServer() {
    this.captchaClient.getCaptchaKey().subscribe(result => {
      console.log('enviroment', environment.name)
      if (environment.name != "CORDOVA") {
        this.captchaKey = result
      }
    })
  }
}

